/**
 * Common JS controller.
 *
 * Use this class to run scripts globally and to provide
 * modular helper functions for other scripts classes.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Export the class reference.
 */
export default class InfiniteScroll {

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {

        // Infinite scroll section.
        this.$infiniteScroll = $( '#js-infinite-scroll' );

        // Infinite scroll spinner.
        this.$infiniteScrollSpinner = $( '#js-infinite-scroll-spinner' );

        // Load more button.
        this.infiniteScrollBtn = $( '#js-infinite-scroll-btn' );

        // Detect if we are currently handling infinite scroll request.
        this.handlingInfiniteScroll = false;

        // Infinite scroll triggers three times, until load more button is displayed.
        // This variable keeps count of how many times infinite scroll is triggered.
        // This will be reseted when load more button is clicked.
        this.loadCount = 0;
    }

    /**
     * All common events
     * @return {void}
     */
    events() {

        // Handle scrolling event.
        $( window ).scroll( () => {
            this.handleInfiniteScroll();
        });

        // Handle infinite scroll button click.
        this.infiniteScrollBtn.on( 'click', () => {
            this.handleInfiniteScrollBtn();
        });
    }

    initInfiniteScroll() {
        if ( this.$infiniteScroll.length ) {

            // Get DustPress model that should be used when retrieving data.
            this.dpModel = this.$infiniteScroll.data( 'model' );

            // Get DustPress partial that be used when retrieving data.
            this.dpPartial = this.$infiniteScroll.data( 'partial' );

            // Define the element where the loaded posts will we appended to.
            const targetElementId = this.$infiniteScroll.data( 'target' );

            // Get the target element.
            if ( targetElementId ) {
                this.targetElement = $( `#${targetElementId}` );
            }

            // Current "page" is always 1 at the start.
            this.page = 1;

            // Get the max page.
            this.maxPage = this.$infiniteScroll.data( 'max-page' );
        }
    }

    /**
     * Handle infinite scroll.
     */
    handleInfiniteScroll() {
        if ( this.$infiniteScroll.length ) {

            // Get window and infinite scroll section bottom positions.
            const windowBottomPos = $( window ).scrollTop() + $( window ).height();
            const bottomPos       = this.$infiniteScroll.position().top + this.$infiniteScroll.outerHeight();

            // Fetch data if window bottom position is under bottom of infinite scroll section.
            if ( windowBottomPos >= bottomPos && ! this.handlingInfiniteScroll && this.page < this.maxPage && this.loadCount < 3 ) {

                // Mark that data is being fetched. This prevents simultaneous requests.
                this.handlingInfiniteScroll = true;

                // Show spinner.
                this.$infiniteScrollSpinner.show();

                // Fetch data!
                dp( this.dpModel, {
                    tidy: true,
                    args: {
                        page: this.page + 1
                    },
                    partial: this.dpPartial,
                    success: ( data ) => {
                        this.successHandler( data );
                    },
                    error: function( error ) {
                        this.errorHandler( error );
                    }
                });
            }
        }
    }

    /**
     * Handle infinite scroll button click.
     */
    handleInfiniteScrollBtn() {

        // Hide infinite scroll button.
        this.infiniteScrollBtn.removeClass( 'active' );

        // Reset load count.
        this.loadCount = 0;

        // Handle infinite scroll, which means "load more" in this case.
        this.handleInfiniteScroll();
    }

    /**
     * Handle successful request.
     *
     * @param {string} data Content HTML string.
     */
    successHandler( data ) {
        this.handlingInfiniteScroll = false;
        this.$infiniteScrollSpinner.hide();
        this.page++;
        this.loadCount++;

        // Append data.
        if ( this.targetElement && data ) {
            this.targetElement.append( data );
        }

        if ( this.loadCount === 3 ) {
            this.infiniteScrollBtn.addClass( 'active' );
        } else {
            this.infiniteScrollBtn.removeClass( 'active' );
        }
    }

    /**
     * Handle failed request.
     *
     * @param {mixed} data Error data.
     */
    errorHandler( error ) {
        this.handlingInfiniteScroll = false;
        this.$infiniteScrollSpinner.hide();
        console.error( error );
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.events();
        this.initInfiniteScroll();
    }
}
